// Logo Marquee - Infinite Seamless Loop
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-logo-marquee-section]');

  sections.forEach(function (section) {
    const track = section.querySelector('[data-marquee-track]');
    const contents = track.querySelectorAll('[data-marquee-content]');

    if (!track || contents.length === 0) return;

    // Get scroll speed from section settings (in seconds)
    const scrollSpeed = section.dataset.scrollSpeed || 30;

    // Set CSS variable for animation duration
    track.style.setProperty('--scroll-speed', scrollSpeed + 's');

    // Calculate total width of one content set for seamless loop
    function calculateContentWidth() {
      const firstContent = contents[0];
      const items = firstContent.querySelectorAll('.marquee-item');
      let totalWidth = 0;

      items.forEach(function (item) {
        const rect = item.getBoundingClientRect();
        totalWidth += rect.width;
      });

      // Add gap between items (80px on desktop, 40px on mobile)
      const gap = window.innerWidth >= 768 ? 80 : 40;
      totalWidth += gap * items.length; // Include gap after last item for track gap

      return totalWidth;
    }

    // Ensure seamless loop by duplicating content if needed
    function ensureSeamlessLoop() {
      const trackWidth = track.getBoundingClientRect().width;
      const contentWidth = calculateContentWidth();

      // If content is narrower than viewport, we need more duplicates
      const duplicatesNeeded = Math.ceil(trackWidth / contentWidth) + 1;
      const currentDuplicates = track.querySelectorAll('[data-marquee-content]').length;

      // Add more duplicates if needed
      for (let i = currentDuplicates; i < duplicatesNeeded; i++) {
        const clone = contents[0].cloneNode(true);
        clone.removeAttribute('data-marquee-content');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    }

    // Initialize on load
    ensureSeamlessLoop();

    // Recalculate on window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        ensureSeamlessLoop();
      }, 250);
    });
  });
});
